import React, { useEffect } from "react";
import masterCardImage from "../../assets/gif/SPT_Card_small-size_rotate (1).gif";
import masterCardIcon from "../../assets/images/mastercard-icon.png";
import "./MasterCard.css";
import AOS from "aos";
import { useTranslation } from "react-i18next";
import Features from "../Features/Features";

const MasterCard = () => {
  const { t } = useTranslation();
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="master-card-container" id="cryptocard">
      <div className="master-card-details">
        <div
          className="master-card-image"
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          <img src={masterCardImage} alt="MasterCard Illustration" />
        </div>
        <div
          className="master-card-text"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <h3>
            Sportrex Crytocard - {t("the")} {t("easiest")} {t("way")} {t("to")}{" "}
            {t("spend")} {t("your")} {t("crypto")} {t("anywhere")},{" "}
            {t("anytime")}!
            <img src={masterCardIcon} alt="" className="master-card-icon" />
          </h3>
          <p>
            {t("Use")} {t("your")} Sportrex CryptoCard {t("anywhere")}{" "}
            Mastercard {t("is")} {t("accepted")}, {t("from")} {t("online")}{" "}
            {t("games")} {t("to")} {t("any")} {t("store")} {t("globally")}.{" "}
            {t("With")} {t("instant")} {t("crypto")}-{t("to")}-{t("cash")}{" "}
            {t("conversions")}, {t("you")} {t("can")} {t("spend")} {t("your")}{" "}
            {t("crypto")} {t("without")} {t("any")} {t("hassles")}. With{" "}
            <strong>Mastercard's </strong>
            {t("top")}-{t("notch")} {t("security")} {t("and")}{" "}
            <strong>Sportrex's {t("blockchain")} </strong> {t("backbone")},{" "}
            {t("your")} {t("assets")} {t("are")} {t("always")} {t("safe")}{" "}
            {t("and")} {t("secure")}.
            <br />
            <br />
            <strong>
              {t("The")} Sportrex CryptoCard {t("is")} {t("the")} {t("perfect")}{" "}
              {t("way")} {t("to")} {t("get")} {t("the")} {t("most")} {t("out")}{" "}
              {t("of")} {t("your")} {t("crypto")}.
            </strong>
          </p>
        </div>
      </div>
      <Features />
    </div>
  );
};

export default MasterCard;
